import { atom } from 'recoil';

export const isUnitModalOpen = atom<boolean>({
  key: 'unit.isModalOpen',
  default: false,
});
